// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Checkbox_wrap__3SX5h","check":"Checkbox_check__8G8q9","text":"Checkbox_text__cw-BL","checked":"Checkbox_checked__R4oT6"};